import sanitizeHtml from 'sanitize-html';

const OPTIONS = {
  allowedTags: [
    ...sanitizeHtml.defaults.allowedTags,
    'img',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    's',
    'u',
  ],
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    img: ['src', 'alt', 'width', 'height'],
  },
  allowedSchemesByTag: { img: ['http', 'https', 'data'] },
};

export function sanitizeDiaryHtml(html) {
  return sanitizeHtml(html ?? '', OPTIONS);
}
